module.exports = __webpack_public_path__ + "img/4dlabs_logo_icon_white.b42041c6.svg";